import { css } from '@emotion/react';
import { Button, Space, Table, TableColumnsType } from 'antd';
import { AddDishesSearcher } from '../../forms/nutritional-menu-calculator-management/add-dishes-search.form';
import { PAGINATION_PARAMS } from '@/constants/pagination.constant';

// import {
//     watchDetailFoodById,
// } from '@/redux/slices/food.slice';
import {
    watchListFilterDish,
    resetListFilterDish,
    watchPaginationFilterDish,
    getListFilterDishObject,
    watchNutritionalMenuCalculatorDishLoading,
} from '@/redux/slices/nutritional-menu-calculator.slice';

import {
    watchListDishAge,
    // watchListDishCookingMethod,
    watchListSourceDish,
    watchListStructureMealDish,
    watchListRegionDish,
    getListDishAge,
    getDetailDish
} from '@/redux/slices/dish.slice';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useCallback, useEffect, useState } from 'react';
import { TableRowSelection } from 'antd/es/table/interface';

type FoodInformationModalProps = {
    onCancel: () => void;
    setSetSelectedRow: (rows: Dish[]) => void;
};

type PageChangeParams = {
    offset?: number;
    pageSize?: number;
    filter?: FilterDishNutritionalMenuCalculator;
};


export const AddDishesModal = ({
    onCancel,
    setSetSelectedRow
}: FoodInformationModalProps) => {
    // const [form] = Form.useForm();
    // const detailFood = useAppSelector(watchDetailFoodById);
    // const [selectedDishes, setSelectedDishes] = useState<Dish[]>([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const dataSource = useAppSelector(watchListFilterDish);
    const listDishAge = useAppSelector(watchListDishAge);
    const listRegion = useAppSelector(watchListRegionDish);
    const listSourceDish = useAppSelector(watchListSourceDish);
    const listStructureMealDish = useAppSelector(watchListStructureMealDish);
    const pagination = useAppSelector(watchPaginationFilterDish);
    const loading = useAppSelector(watchNutritionalMenuCalculatorDishLoading);
    const [filter, setFilter] = useState<FilterDishNutritionalMenuCalculator>({});
    const dispatch = useAppDispatch();
    const [loadingDetails, setLoadingDetails] = useState(false);

    useEffect(() => {
        dispatch(getListDishAge());
        dispatch(resetListFilterDish());
    }, [dispatch]);

    // const onEdit = () => {
    //     onCancel();
    //     // dispatch(getDetailDish(selectedRowKeys));
    //     setSetSelectedRow(selectedDishes);
    // }

    const loadDetails = async () => {
        setLoadingDetails(true);

        const details: Dish[] = [];

        for (const id of selectedRowKeys) {
            const dish = dataSource.find((item) => item.dishId === id);
            const ageGroupId = dish?.ageGroupId;
            const res = await dispatch(getDetailDish({ id: String(id), ageGroupId: ageGroupId ? String(ageGroupId) : undefined })).unwrap();

            if (res) {
                details.push(res);
            }
        }

        setSetSelectedRow(details);
        setLoadingDetails(false);
        onCancel();
    };

    const handlePageChange = useCallback(
        ({
            offset = PAGINATION_PARAMS.offset,
            pageSize = PAGINATION_PARAMS.limit,
            filter
        }: PageChangeParams) => {
            dispatch(getListFilterDishObject({ query: filter, offset, limit: pageSize }));
        },
        [dispatch]
    );

    const handleSearch = (values: FilterDish) => {
        const newFilter = {
            ...filter,
            ...values
        };
        setFilter(newFilter);
        handlePageChange({ filter: newFilter });
    };

    const rowSelection: TableRowSelection<Dish> = {
        selectedRowKeys,
        onChange: (newSelectedRowKeys: React.Key[], ) => {
            setSelectedRowKeys(newSelectedRowKeys);
            // setSelectedDishes(selectedRows);
            // selectedRows: Dish[]
        },
        columnTitle: 'Chọn',
    };

    const columns: TableColumnsType<any> = [
        {
            title: 'ID món ăn',
            render: (_, __, index) => index + 1
        },
        {
            title: 'Tên món ăn',
            dataIndex: 'name',
            key: 'name',
            width: 200,
            fixed: 'left',
        },
        {
            title: 'Độ tuổi',
            dataIndex: 'ageGroupId',
            key: 'ageGroupId',
            width: 100,
            render: (ageId: number | string) => {
                const age = listDishAge.find((r) => r.id === ageId);
                return age?.name || '-';
            }
        },
        {
            title: 'Miền',
            dataIndex: 'regionId',
            key: 'regionId',
            width: 200,
            render: (regionId: number | string) => {
                const region = listRegion.find((r) => r.regionId === regionId);
                return region?.regionName || '-';
            }
        },
        {
            title: 'Nguồn món ăn',
            dataIndex: 'externalDishTypeId',
            key: 'externalDishTypeId',
            width: 300,
            render: (externalDishId: number | string) => {
                const externalDish = listSourceDish.find((r) => r.id === externalDishId);
                return externalDish?.name || '-';
            }
        },
        {
            title: 'Nhóm món ăn theo phương pháp nấu',
            dataIndex: 'cookingMethodId',
            key: 'cookingMethodId',
            width: 300,
            // render: (value: string) => {
            //     const plainText = value.replace(/<[^>]+>/g, '');
            //     return plainText;
            // }
        },
        {
            title: 'Nhóm món ăn theo cấu trúc bửa',
            dataIndex: 'mealStructureId',
            key: 'mealStructureId',
            width: 150,
            render: (structureId: number | string) => {
                const structure = listStructureMealDish.find((r) => r.id === structureId);
                return structure?.name || '-';
            }
        },
    ];

    return (
        <div css={rootStyles}>
            <AddDishesSearcher handleSearch={handleSearch} />

            <Table<any>
                rowKey="dishId"
                rowSelection={rowSelection}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    showQuickJumper: true,
                    showSizeChanger: true,
                    current: pagination.curPage,
                    pageSize: pagination.limitPage,
                    total: pagination.totalRows,
                    onChange: (offset, pageSize) => {
                        handlePageChange({ offset, pageSize });
                    }
                }}
            />
            <Space css={groupButtonStyles}>
                <Button type='default' size='large' onClick={onCancel}>
                    Hủy
                </Button>
                <Button 
                type='primary' 
                size='large' 
                // onClick={onEdit}}
                onClick={loadDetails}
                loading={loadingDetails}
                >
                    Thêm
                </Button>
            </Space>
        </div>
    );
};

const groupButtonStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  margin-top: 1.6rem;

  button {
    padding: 2rem 4rem;
  }
`;

const rootStyles = css`
  background: var(--white-soft-color);
  display: flex;
  flex-direction: column;
  /* gap: 1.4rem; */
  min-height: calc(100vh - var(--header-height));
`;
